<template>
  <div class="web__loader">
    <b-spinner></b-spinner>
    <p>Creando, no recarges la pagina</p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>